<template>
	<v-app>
		<layout v-if="site && marketData" />
	</v-app>
</template>

<script>
	import { mapActions, mapState } from 'vuex';
	import Layout from './components/layout';

	export default {
		name: 'app',

		components: {
			Layout
		},

		data: () => ({
			//
		}),

		computed: {
			...mapState('App', ['site', 'marketData'])
		},

		created() {
			this.getSiteConfig();
			this.getMarketData();
		},

		methods: {
			...mapActions('App', ['getSiteConfig', 'getMarketData'])
		}
	};
</script>
